<template>
  <div class="container">
    <div v-if="signupForm && canSignUp" class="row">
      <div class="container justify-content-center form-base p-4">
        <div class="row">
          <div class="mx-auto mt-5 mb-3">
            <b-img v-if="signupForm.logo != ''" :src="getFormsImageUrl(signupForm.logo)"
              :alt="$t(LangConstants.form_image_alt_text)" class="logo"></b-img>
          </div>
        </div>
        <div class="row mb-2">
          <div class="mx-auto text-center">
            <h1>{{ signupForm.title }}</h1>
          </div>
        </div>
        <div class="row mb-3">
          <div class="mx-auto text-center px-3">
            <p>{{ signupForm.description }}</p>
          </div>
        </div>
        <b-form ref="frmBasicData" @submit.stop.prevent="submitForm">
          <div class="row">
            <template v-for="mfieldset in mandatoryFields">
              <div v-for="mfield in mfieldset.fields" v-bind:key="mfield" class="col-md-6">
                <div class="mb-4 col-md-12">
                  <my-input :id="mfield.value" name="my-name" mandatory="true" :label="$t(mfield.label)"
                    :placeholder="$t(mfield.placeholder)" inlinerows="false" classes="bg-gray" :type="mfield.type"
                    :ref="mfield.label"
                    :error="mfield.type == 'password' && v$.password.$error == true ? v$.password.$errors[0].$message : ''"></my-input>
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div v-for="nmmfields in nonMandatoryFields" v-bind:key="nmmfields" class="col-md-12"
              :data-fieldset="nmmfields.value">
              <div v-if="SelectedNonMandatory.includes(nmmfields.value)">
                <div v-if="nmmfields.label" class="col-md-12 mt-2 mb-2">
                  <div class="row">
                    <div class="col-md-6">
                      <h4>{{ nmmfields.label }}</h4>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div :id="nmmfields.value" v-for="nmmfield in nmmfields.fields" v-bind:key="nmmfield"
                      class="col-md-6">
                      <template v-if="nmmfields.value == 7">
                        <selector v-if="nmmfield.id == 1 && hasCustomCompanies" :id="nmmfield.value" name="my-name"
                          mandatory="true" :label="$t(nmmfield.label)" inlinerows="false" classes="bg-gray"
                          :type="nmmfield.type" ref="companyName" :data="companyNames" valuefield="companyname"
                          textfield="companyname"></selector>
                        <my-input v-if="nmmfield.id == 1 && !hasCustomCompanies" :id="nmmfield.value" name="my-name"
                          mandatory="true" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.inputplaceholder)"
                          inlinerows="false" classes="bg-gray" :type="nmmfield.type" ref="companyName"></my-input>
                        <my-input v-if="nmmfield.id != 1" :id="nmmfield.value" name="my-name" mandatory="true"
                          :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)" inlinerows="false"
                          classes="bg-gray" :type="nmmfield.type" :ref="nmmfield.label"></my-input>
                      </template>
                      <template v-if="nmmfields.value != 7">
                        <my-input v-if="nmmfield.type != 'checkbox'" :id="nmmfield.value" name="my-name"
                          mandatory="true" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)"
                          inlinerows="false" classes="bg-gray" :type="nmmfield.type" :ref="nmmfield.label"></my-input>
                        <my-checkbox v-if="nmmfield.type == 'checkbox'" id="orderCertificate" name="orderCertificate"
                          inlinerows="false" :defaultText="$t(nmmfield.placeholder)" secondaryText="" checkedValue="1"
                          uncheckedValue="0" :label="$t(nmmfield.label)" :ref="nmmfield.label"> </my-checkbox>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="courseEvents.length > 0">
            <hr class="mt-5">
            <div class="row d-flex align-items-center mt-2 mb-2 form-base list-items-container pt-2 pb-2"
              v-for="event in courseEvents" :key="event.id">
              <div class="col-md-1 pt-2 pl-5 list-item">
                <my-radio v-if="canRegister(event)" :id="eventSelectionId(event.id)" name="eventsSelection"
                  inlinerows="false" defaultText="" secondaryText="" :value="event.id" label=""
                  @input="selectEvent(event.id)"></my-radio>
              </div>
              <div class="col-md-2 list-item">
                <div>
                  <b>{{ $t(LangConstants.on) }} : </b>
                </div>
                {{ dayjs(formatEpochDate(event.start_date)).format("DD MMMM") /* + " - " +
                dayjs(formatEpochDate(event.end_date)).format("DD MMM") */ }}
              </div>
              <div class="col-md-2 list-item">
                <div>
                  <b>{{ $t(LangConstants.at) }} : </b>
                </div>
                {{ event.location }}
              </div>
              <div class="col-md-2 list-item">
                <div>
                  <b>{{ $t(LangConstants.available) }} : </b>
                </div>
                {{ (event.available_slots ? event.available_slots : 0) + " " + LangConstants.out_of_text + " " +
                  event.max_attendance_count }}
              </div>
              <div class="col-md-3 list-item">
                <div>
                  <b>{{ $t(LangConstants.ends_on) }} : </b>
                </div>
                {{ dayjs(formatEpochDate(event.last_registration_date)).format("DD MMMM") }}
              </div>
            </div>
            <hr class="mt-3 mb-3">
          </template>
          <template v-if="signupForm.captcha">
            <div class="row">
              <div class="col-md-12 mx-3">
                <div class="col-md-12">
                  <captcha @isValid="handleCaptcha" />
                </div>
              </div>
            </div>
          </template>

          <div class="row mt-4 mb-2">
            <div class="col-md-12">
              <my-checkbox id="agreeToSitePolicy" name="agreeToSitePolicy" inlinerows="false" defaultText=""
                secondaryText="" checkedValue="1" uncheckedValue="0" label="" @input="agreeToPolicy">
                <span class="checkbox-default-text"> I agree to the <a :href="privacyPolicyUrl" target="_blank">site
                    policy</a></span>
              </my-checkbox>
            </div>
          </div>

          <b-modal id="signup-questions-model" hide-footer class="signup-questions-model pt-5" size="lg"
            v-model="showSignupFormQuestions" :hide-header-close="true" :no-close-on-backdrop="true"
            title="Event Registration">
            <div class="" v-if="signupQuestions">
              <div class="col-md-12" v-for="(signupQuestion, index) in signupQuestions" :key="index">
                <div class="mb-4" v-if="signupQuestion.type == 1">
                  <my-input :id="'signup-form-field-' + index" name="'signup-form-field-'+index"
                    :label="signupQuestion.question" placeholder="" inlinerows="false" classes="bg-gray"
                    ref="SignupFormField" v-model="signupQuestion.changedvalue"
                    @input="addAnswer(signupQuestion.questionid)"></my-input>
                </div>
                <div class="mb-4" v-if="signupQuestion.type == 2">
                  <label for="multivaluesignupformfield" class="form-label">{{ signupQuestion.question }}</label>
                  <my-checkbox v-for="(option, index) in signupQuestion.options" :key="index" :id="index" name="option"
                    inlinerows="false" :defaultText="option" secondaryText="" :checkedValue="option"
                    :uncheckedValue="null" label="" v-model="signupQuestion.changedvalue"
                    @input="addOptionValue(signupQuestion.questionid, option)">
                  </my-checkbox>
                </div>
              </div>
            </div>
            <hr class="mt-5">
            <div class="text-center">
              <my-button :label="$t(LangConstants.save_button_label)" variant="solid-primary" classes="mr-2 mt-1 mb-2"
                width="20%" height="55px" @onClick="saveQuestions()"></my-button>
              <my-button :label="$t(LangConstants.cancel_button_label)" variant="solid-grey" classes="mr-2 mt-1 mb-2"
                width="20%" height="56px" @onClick="hideQuestions()"></my-button>
            </div>
          </b-modal>

          <my-button :label="$t(LangConstants.submit_button_label)" variant="solid-primary" classes="mr-1 mt-3 mb-2"
            height="56px" width="100%" type="submit" ref="submitBtn" :isDisabled="!isSubmitButtonEnabled()"></my-button>
        </b-form>
      </div>
    </div>

    <div v-if="!canSignUp && this.$store.getters.contentLoading == false" class="row mt-5 ">
      <no-data-box>
        <h5>There is no any available active course event for registration</h5>
      </no-data-box>
    </div>

    <div v-if="!signupForm && this.$store.getters.contentLoading == false" class="row mt-5 ">
      <no-data-box>
        <h5>{{ $t(LangConstants.form_not_available_text) }}</h5>
      </no-data-box>
    </div>
  </div>
</template>

<script>
/**
 * Signup Forms - Public Page
 */
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import "../../../assets/scss/signup-form.scss";
import MyInput from "../../../components/atoms/Input.vue";
import MyCheckbox from "../../../components/atoms/Checkbox.vue";
import MyRadio from "../../../components/atoms/Radio.vue";
import MyButton from "../../../components/atoms/Button.vue";
import Captcha from "../../../components/organisms/Captcha.vue";
import Csrf from "../../../apis/Csrf";
import NoDataBox from "../../../components/atoms/NoDataBox.vue";
import Constants from "../../../constants/index";
import common from "../../../functions/index";
import Selector from "../../../components/atoms/Selector.vue";

const dayjs = require("dayjs");

export default {
  name: "signup-form",
  async beforeCreate() {
    const userSignupFormId = this.$route.params.formId;
    var self = this;
    await this.$store.dispatch("getSignupFormByGuid", userSignupFormId).then(function (form) {
      if (form.success) {
        self.signupForm = form.data;

        self.hasDoneCaptcha = !self.signupForm.captcha ? true : false;

        self.courses = self.signupForm.sign_up_form_has_course;

        if (self.courses.length == 1 && self.courses[0].course.type == "instructor_led_training") {
          self.courseType = "instructor_led_training";
          self.courseEvents = self.courses[0].course.published_course_events;
        }

        self.hasCourseEvents = self.courseType == "instructor_led_training";

        self.canSignUp = self.hasCourseEvents ? self.courseEvents && self.courseEvents.length > 0 : true;

        if (self.canSignUp && self.hasCourseEvents) {
          var eventsWithAvailableSlots = self.courseEvents.filter(ce => ce.available_slots > 0);

          if (eventsWithAvailableSlots.length == 0) {
            self.canSignUp = false;
          } else {
            let datenow = Date.now() / 1000;
            var eventsWithRegistrationEnabled = eventsWithAvailableSlots.filter(ce => ce.last_registration_date > datenow);

            if (eventsWithRegistrationEnabled.length == 0) {
              self.canSignUp = false;
            }
          }
        }

        self.pushNonMandatoryFields(form.data);
      }

      // this.pushNonMandatoryFields(this.signupForm);
    });

    //this.$store.commit('applogo', this.$store.getters.storageUrl +  self.signupForm.logo );
  },

  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      password: {
        required,
        passwordMustBeValid: helpers.withMessage(this.$t(Constants.general_password_validation_message), this.passwordMustBeValid),
      },
    };
  },

  mounted() { },

  created() { },

  data() {
    return {
      signupForm: null,
      userData: {},
      SelectedNonMandatory: [],
      password: "",
      agreeToSitePolicy: 0,
      course: null,
      courseEvents: [],
      canSignUp: false,
      selectedEvent: null,
      signupQuestions: null,
      showSignupFormQuestions: false,
      signupErrorMsg: null,
      hasCourseEvents: false,
      hasDoneCaptcha: false,
      customCompanyInfo: null,
      courses: [],
      courseType: 'elearning',
      hasCustomCompanies: false,
      companyNames: []
    };
  },

  computed: {
    privacyPolicyUrl() {
      return this.$store.getters.instanceUrl + "/local/sparkfore_api/policy.php";
    },
    mandatoryFields() {
      return this.$store.state.mandatoryFields;
    },
    nonMandatoryFields() {
      return this.$store.state.nonMandatoryFields;
    },
    LangConstants() {
      return Constants;
    },
    dayjs() {
      return dayjs;
    },
    hasCourseSelected() {
      return this.selectedEvent != null;
    },
    // hasCustomCompanies() {
    //   console.log()
    //   return this.customCompanyInfo && this.customCompanyInfo.length > 0;
    // }
  },
  methods: {
    isSubmitButtonEnabled() {
      if (!this.agreeToSitePolicy) {
        return false;
      } else if (this.hasCourseEvents && !this.hasCourseSelected) {
        return false;
      } else if (!this.hasDoneCaptcha) {
        return false;
      }
      return true;
    },

    canRegister(event) {
      let datenow = Date.now() / 1000;
      return event.available_slots > 0 && event.last_registration_date > datenow;
    },

    passwordMustBeValid(value) {
      const re = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[-=_)(*^%$@!~`])[A-Za-z\d-=_)(*^%$@!~`]{6,}$/);
      return re.test(value);
    },

    getFormsImageUrl(partial) {
      const isValidUrl = common.isValidHttpUrl(partial);

      if (isValidUrl == true) {
        return partial;
      } else if (isValidUrl != true && partial != "") {
        return this.getUrl(partial);
      } else {
        const images = require.context("../../../assets/imgs/", false, /\.png$/);
        return images("./placeholder.png");
      }
    },

    getUrl(partial) {
      return this.$store.getters.storageUrl + partial;
    },

    pushNonMandatoryFields(signupForm) {
      for (let i = 0; i < signupForm.sign_up_form_has_custom_field.length; i++) {
        if (signupForm.sign_up_form_has_custom_field[i].sign_up_form_custom_field.mandatory == false) {
          if (signupForm.sign_up_form_has_custom_field[i].sign_up_form_custom_field.id == 7) { //customcompany selection
            let val = JSON.parse(signupForm.sign_up_form_has_custom_field[i].value);

            console.log(signupForm.sign_up_form_has_custom_field[i]);
            //['CompanyName', 'Address', 'ZipCode', 'Location', 'BillingCode']
            this.customCompanyInfo = val;
            this.hasCustomCompanies = this.customCompanyInfo && this.customCompanyInfo.length > 0;

            if (this.hasCustomCompanies) {
              this.customCompanyInfo.forEach(com => {
                this.companyNames.push({ 'companyname': com });
              });
            }
          }
          this.SelectedNonMandatory.push(signupForm.sign_up_form_has_custom_field[i].sign_up_form_custom_field.id);
        }
      }
    },

    selectEvent(eventid) {
      this.deselectEvent();
      Array.from(document.querySelectorAll('input[name="eventsSelection"]')).map((ref) => {
        if (ref.value == eventid) {
          ref.checked = true;
        } else {
          ref.checked = false;
        }
      });
      this.selectedEvent = this.courseEvents.find(e => e.id == eventid);
      this.signupQuestions = JSON.parse(this.selectedEvent["registration_form"]);
      if (this.signupQuestions) {
        if (!Array.isArray(this.signupQuestions)) {
          this.signupQuestions = [{ questionid: 0, question: this.signupQuestions.question, type: 1, value: null }];
        } else {
          this.signupQuestions.forEach(qst => {
            qst.value = null;
            qst.changedvalue = null;
          });
        }
        this.showSignupFormQuestions = true;
      }
      this.updateSubmitButtonState();
    },

    addOptionValue(questionId, option) {
      this.signupQuestions.forEach(qst => {
        if (qst.type == 2 && qst.questionid == questionId) {
          let values = [];
          if (qst.value) {
            values = JSON.parse(qst.value);
          }
          if (qst.changedvalue && qst.changedvalue == option) {
            values.push(option);
          } else {
            const index = values.indexOf(option);
            if (index !== -1) {
              values.splice(index, 1);
            }
          }
          qst.value = JSON.stringify(values);
        }
      });
    },

    addAnswer(questionId) {
      this.signupQuestions.forEach(qst => {
        if (qst.type == 1 && qst.questionid == questionId) {
          qst.value = JSON.stringify([qst.changedvalue]);
        }
      });
    },

    deselectEvent() {
      this.selectedEvent = null;
      this.updateSubmitButtonState();
    },

    hideQuestions() {
      this.showSignupFormQuestions = false;
      // const modal = document.getElementById("signup-questions-model");
      // if (modal) {
      //   modal.style.display = "none";
      // }
      this.signupQuestions.forEach(qst => {
        qst.value = null;
      });
    },

    saveQuestions() {
      this.showSignupFormQuestions = false;
    },

    formatEpochDate(date) {
      return common.epochToJsDate(date);
    },

    eventSelectionId(eventid) {
      return "eventSelectionId-" + eventid;
    },

    fetchUserInputs() {
      let inputs = {
        user: {
          first_name: this.$refs["First Name"][0].text,
          last_name: this.$refs["Last Name"][0].text,
          email: this.$refs["Email"][0].text,
          password: this.$refs["Password"][0].text,
        },
        custom_data: {},
      };

      this.password = this.$refs["Password"][0].text;

      const inputMap = {
        "First Name": "first_name",
        "Last Name": "last_name",
        Email: "email",
        Password: "password",
        "Mobile Phone": "phone",
        "Home Phone": "home_phone",
        "Company name": "company",
        Address: "address",
        "Zip Code": "zip_code",
        Location: "officelocation",
        "Billing Code": "billing_code",
        "Employment Number": "employment_number",
        "Order Certificate": "order_certificate",
      };

      for (const nmField of this.nonMandatoryFields) {
        if (this.SelectedNonMandatory.includes(nmField.value)) {
          if (nmField.value == 7) {
            if (this.hasCustomCompanies) {
              inputs["user"][inputMap["Company name"]] = this.$refs["companyName"][0].selectedrow;
            } else {
              inputs["user"][inputMap["Company name"]] = this.$refs["companyName"][0].text;
            }
            inputs["user"][inputMap["Address"]] = this.$refs["Address"][0].text;
            inputs["user"][inputMap["Zip Code"]] = this.$refs["Zip Code"][0].text;
            inputs["user"][inputMap["Location"]] = this.$refs["Location"][0].text;
            inputs["user"][inputMap["Billing Code"]] = this.$refs["Billing Code"][0].text;
            inputs["user"][inputMap["Employment Number"]] = this.$refs["Employment Number"][0].text;
          } else if (nmField.value == 6) {
            inputs["user"][inputMap["Home Phone"]] = this.$refs["Home Phone"][0].text;
          } else {
            if (nmField.fields && nmField.fields[0].type == "checkbox") {
              inputs["user"][inputMap[nmField.text]] = this.$refs[nmField.text][0].status;
            } else {
              inputs["user"][inputMap[nmField.text]] = this.$refs[nmField.text][0].text;
            }
          }
        }
      }

      return inputs;
    },

    submitForm() {
      if (this.agreeToSitePolicy == 0) {
        this.$bvToast.toast("Please agree to the site policy before proceeding to register.", {
          title: "Information",
          autoHideDelay: 4000,
          appendToast: false,
        });

        return;
      }

      let userForm = this.fetchUserInputs();
      userForm.formId = this.$route.params.formId;

      const formData = {
        jsondata: {
          user: {
            first_name: userForm.user.first_name, //"Minima aut labore ad",
            last_name: userForm.user.last_name, //"Dolore beatae et acc",
            email: userForm.user.email, //"nynirulypo@mailinator.com",
            password: userForm.user.password, //"Pa$$w0rd!",
            phone1: userForm.user.phone, //"Rerum voluptas quis ",
            company_2: userForm.user.company, //"Rerum sint odio odi",
            address: userForm.user.address, //"Tempora dolor id hic",
            officelocation: userForm.user.officelocation, //"Voluptatem sunt vol",
            order_certificate: userForm.user.order_certificate, //"1",
            phone2: userForm.user.home_phone, //"Officiis quaerat ab ",
            region: userForm.user.zip_code, //"Sed aliqua Neque ex",
            billing_code: userForm.user.billing_code, //"Aut ut nesciunt et ",
            employeeid: userForm.user.employment_number, //"Eligendi dolor exerc"
            participants: [
              {
                email: userForm.user.email, //"nynirulypo@mailinator.com",
                signupFields: this.signupQuestions,
              },
            ],
            eventid: this.hasCourseEvents && this.selectedEvent ? this.selectedEvent.courseeventid : null
          },

          formId: userForm.formId, //"789F8CBD-360A-43C1-8963-AF5D595D572F"
        },
        formId: userForm.formId, //"789F8CBD-360A-43C1-8963-AF5D595D572F"
      };

      this.v$.password.$touch();
      if (!this.v$.$error) {
        this.$store.dispatch("registerUser", formData).then((result) => {

          // const store = this.$store;value
          // const formId = this.$route.params.formId;

          if (result.status == "success") {
            this.$store.dispatch("updateRegCount", { formId: this.$route.params.formId }).then(() => { });
            this.$fire({
              title: this.$t(result.message),
              type: "success",
              timer: 6000,
            }).then(function () {
              if (result.loginurl) {
                Csrf.setCookie("MoodleSession", result.MoodleSession);
                window.location.href = result.loginurl;
              }
            });
          } else {
            this.$fire({
              title: this.$t(result.message),
              type: "error",
              html: this.$t(result.error),
            });
          }
        });
      }
    },

    agreeToPolicy(e) {
      this.agreeToSitePolicy = e;
      this.updateSubmitButtonState();
    },

    handleCaptcha(isValid) {
      this.hasDoneCaptcha = isValid;
    },

    updateSubmitButtonState() {
      if (this.isSubmitButtonEnabled()) {
        this.$refs.submitBtn.isDisabled = false;
      } else {
        this.$refs.submitBtn.isDisabled = true;
      }
    }
  },
  components: {
    MyInput,
    MyButton,
    Captcha,
    NoDataBox,
    MyCheckbox,
    MyRadio,
    Selector
  },
};
</script>
